import { Col, message, Row } from "antd";
import { useMutation, useQueryClient } from "react-query";
import registerApi from "../../../api/registerApi";
import RegisterCommon from "../../../components/RegisterCommon";
import TopContent from "../../../components/TopContent";
import PageWrap from "../../../layout/PageWrap";
import { appRoutes } from "../../../routes/routes";
import { messages } from "../../../utils/messages";

const RegisterList = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(registerApi.delete, {
    onSuccess: (data: any) => {
      if (data.statusCode === 200) {
        message.success(messages.deleteSuccess);
        queryClient.invalidateQueries("register_train");
        queryClient.invalidateQueries("noti");
      } else {
        message.error(data?.data?.message ?? messages.error);
      }
    },
    onError: (err: any) => {
      message.error(err?.data?.message ?? messages.error);
    },
  });

  return (
    <PageWrap
      title="Đăng ký đào tạo"
      content={
        <div className="slider_list">
          <TopContent
            content={
              <Row>
                <Col>
                  <b>Đăng ký đào tạo</b>
                </Col>
              </Row>
            }
          />
          <RegisterCommon
            keyQuery="register_train"
            query={registerApi.getAll}
            link={appRoutes.REGISTER.ROOT}
            action={mutation}
          />
        </div>
      }
    />
  );
};

export default RegisterList;
